// notifPaging.mjs — SB-159（第三百八十二批）：通知铃的「加载更多」。纯函数（SB-042）。
//
// ── 病灶 ──────────────────────────────────────────────────────────────────────
// 铃铛一次取 15 条，挨着一个能显示 99+ 的角标；比这 15 条更旧的未读**够不着、也没有任何一个字
// 说够不着**——角标说 40，列表里 15 行，读的人只能猜另外 25 条在哪儿（全系统没有通知列表页）。
// 管理员账号每一次工单事件都落一行，这是增长最快的表之一。需求方报的审批浏览那一幕与此同形：
// 「这一页 N 条」与「一共 N 条」长得一模一样。
//
// 三件事，各一只函数：
//   · mergeNotifPages —— 追加下一页并按 id 去重（键集游标本不该重叠；去重兜住偶发的重放）；
//   · unreadOutside   —— 服务端的 unreadCount 减去已载入的未读行：>0 就在铃铛里说「另有 N 条未读
//     不在上面」。**它不看 hasMore**：服务端若说谎（hasMore=false 而未读其实还有），这一行照样出现；
//   · showLoadMore    —— 只在服务端说 `hasMore === true` 时出「加载更多」——一个永远在那儿的
//     按钮等于没说话（SB-159 §5 第一百三十一批那条）。
//   · unreadOutsideKey／loadMoreLabelKey（复审 N6）—— 那一句该怎么说、按钮在取时写什么，见各自头注。

export const BELL_PAGE_LIMIT = 15;

export function mergeNotifPages(prev, body) {
  const out = Array.isArray(prev) ? [...prev] : [];
  const seen = new Set(out.map((n) => n?.id));
  for (const n of Array.isArray(body?.notifications) ? body.notifications : []) {
    if (seen.has(n?.id)) continue;
    seen.add(n?.id);
    out.push(n);
  }
  return out;
}

export function unreadOutside(rows, unreadCount) {
  const loaded = (Array.isArray(rows) ? rows : []).filter((n) => n?.readAtMs == null).length;
  const total = Number(unreadCount);
  return Number.isFinite(total) ? Math.max(0, total - loaded) : 0;
}

export function showLoadMore(body) {
  return body?.hasMore === true;
}

// 复审（N6）：「另有 N 条未读」那一句随「加载更多」在不在换说法。此前它恒说「点『加载更多』往前翻」，
// 而这一行在**没有**那颗按钮时也会出现：旧后端（无 hasMore）、服务端说没有更多、或菜单开着时 60 秒轮询
// 把角标抬高了——那时缺的那几条是**更新的**，根本不在更早的页里，叫人往前翻是指错方向。
// 有按钮 ⇒ 照旧往前翻；没按钮 ⇒ 重新打开铃铛刷新（重新打开就是重取最新一页）。
export function unreadOutsideKey(page) {
  return showLoadMore(page) ? 'notif.unreadOutside' : 'notif.unreadOutsideReopen';
}

// 「加载更多」那一项在取下一页时的字样（与 dm.loadMoreBusy／secrets.loadMoreBusy 同款）：按了之后
// 它是 disabled 的，字不变的话看着就像按坏了。
export function loadMoreLabelKey(more) {
  return more?.loading ? 'notif.loadMoreBusy' : 'notif.loadMore';
}
